<template>
    <v-row>
        <v-col v-for="(column, index) in columns" :key="index" cols="12" md="6" lg="4">
        <eod-textarea  hide-details outlined rows="2" auto-grow
            :label="getColumnLabel(column)" :disabled="readonly"
            :value="values[getColumnLabel(column)]"
            @input="val => updateColumn(getColumnLabel(column), val)"></eod-textarea>
            </v-col>
    </v-row>
</template>
<script>
export default {
    name: 'eod-measurement-table',
    props: {
        readonly: Boolean,
        measurementType: Object,
        value: String | Object,
    },
    data() {
        return {
            values: this.parseValue(this.value)
        }
    },
    computed: {
        columns() {
            if (this.measurementType && this.measurementType.formConfig && this.measurementType.formConfig.columns) {
                return this.measurementType.formConfig.columns;
            }

            return [];
        }
    },
    watch: {
        value(val) {
            if (JSON.stringify(this.values) == val) {
                return;
            }

            this.values = this.parseValue(val);
        }
    },
    methods: {
        parseValue(value) {
            if (!value) {
                return {};
            }

            if (typeof value == 'object') {
                return value;
            }

            try {
                const parsed = JSON.parse(value);
                return (parsed && typeof parsed == 'object') ? parsed : {};
            } catch (e) {
                return {};
            }
        },
        getColumnLabel(column) {
            if (column && typeof column == 'object') {
                return column.text || column.name || '';
            }

            return column;
        },
        updateColumn(label, val) {
            this.$set(this.values, label, val);
            this.$emit('input', JSON.stringify(this.values));
        }
    }
}
</script>
